var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4492 0.308739V3.51562H17.6559L14.4492 0.308739Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 4.57031C13.6306 4.57031 13.3945 4.3342 13.3945 4.04297V0H5.83594C4.96361 0 4.25391 0.709699 4.25391 1.58203V7.47735C4.42765 7.4616 4.60346 7.45312 4.78125 7.45312C6.57872 7.45312 8.18779 8.27494 9.25263 9.5625H14.9766C15.2678 9.5625 15.5039 9.79861 15.5039 10.0898C15.5039 10.3811 15.2678 10.6172 14.9766 10.6172H9.94739C10.277 11.2604 10.4896 11.973 10.5578 12.7266H14.9766C15.2678 12.7266 15.5039 12.9627 15.5039 13.2539C15.5039 13.5451 15.2678 13.7812 14.9766 13.7812H10.5578C10.4001 15.5229 9.46958 17.0447 8.11259 18H16.3828C17.2551 18 17.9648 17.2903 17.9648 16.418V4.57031H13.9219ZM14.9766 7.45312H7.24219C6.95095 7.45312 6.71484 7.21702 6.71484 6.92578C6.71484 6.63455 6.95095 6.39844 7.24219 6.39844H14.9766C15.2678 6.39844 15.5039 6.63455 15.5039 6.92578C15.5039 7.21702 15.2678 7.45312 14.9766 7.45312Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 8.50781C2.16425 8.50781 0.0351562 10.6369 0.0351562 13.2539C0.0351562 15.8709 2.16425 18 4.78125 18C7.39825 18 9.52734 15.8709 9.52734 13.2539C9.52734 10.6369 7.39825 8.50781 4.78125 8.50781ZM6.1875 13.7812H4.78125C4.49002 13.7812 4.25391 13.5451 4.25391 13.2539V11.1445C4.25391 10.8533 4.49002 10.6172 4.78125 10.6172C5.07248 10.6172 5.30859 10.8533 5.30859 11.1445V12.7266H6.1875C6.47873 12.7266 6.71484 12.9627 6.71484 13.2539C6.71484 13.5451 6.47873 13.7812 6.1875 13.7812Z",
    fill: "#CC5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.6a7d84c9a6dec11bccf15c4a3596cd73.svg";
export { ForwardRef as ReactComponent };